import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaHeading } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";
import { RanaPageTitle } from "@nens/ranalib";

import { BackButton } from "@/components/back-button";
import { BasePage } from "@/components/base-page";
import { AdminTenantCreateOrEdit } from "@/features/admin-tenant";
import { AdminTenantUserList } from "@/features/admin-tenant-user";
import { RanaTabs } from "@/lib/rana-tabs";
import { useInstancePermissions } from "@/queries/query-instance-permissions";
import { useTenantQuery } from "@/queries/query-tenant";

export function AdminTenantPage() {
  const intl = useIntl();
  const { tenant: tenantId } = useContext(TenantContext);
  const { canListTenant } = useInstancePermissions();
  const { data: tenant } = useTenantQuery();

  const ADMIN_TENANT_TABS = {
    settings: {
      title: <FormattedMessage id="tab.settings" defaultMessage="Settings" />,
      panel:
        canListTenant && tenant ? (
          <>
            <RanaPageTitle
              showTenant
              subTitle={intl.formatMessage({
                id: "page_title.settings.settings",
                defaultMessage: "Settings",
              })}
            />
            <AdminTenantCreateOrEdit tenant={tenant} type="editing" />
          </>
        ) : null,
    },
    users: {
      title: <FormattedMessage id="tab.users" defaultMessage="Users" />,
      panel:
        canListTenant && tenant ? (
          <>
            <RanaPageTitle
              showTenant
              subTitle={intl.formatMessage({
                id: "page_title.settings.users",
                defaultMessage: "Users",
              })}
            />
            <AdminTenantUserList />
          </>
        ) : null,
    },
  } as const;
  return (
    <BasePage pageSubTitle={"admin"} activeSidebarButton="admin">
      <BackButton to={`/${tenantId}/admin`}>
        <FormattedMessage
          id="button.choose_other_organisation"
          defaultMessage="Choose other organisation"
        />
      </BackButton>
      <RanaHeading type="h1" addDot>
        <FormattedMessage
          id="heading.admin_for"
          defaultMessage="Admin for {tenant}"
          values={{ tenant: tenantId }}
        />
      </RanaHeading>
      <RanaTabs isPageNav tabs={ADMIN_TENANT_TABS} tabKey="tabs" />
    </BasePage>
  );
}
